import { motion } from "framer-motion";
import { MANIFESTO } from "../../data";

const reveal = {
  hidden: { opacity: 0, y: 60 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.08, duration: 0.8, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto"
      className="mx-auto max-w-[1500px] px-6 py-28 md:px-12 md:py-40"
    >
      <div className="mb-20 grid grid-cols-1 gap-8 md:grid-cols-12">
        <div className="md:col-span-4">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--volt)]">
            / The Standard
          </span>
        </div>
        <h2 className="font-display text-4xl font-bold uppercase leading-[1.05] tracking-tight text-white md:col-span-8 md:text-6xl">
          We don&apos;t fix cars.
          <br />
          <span className="text-stroke">We recalibrate them.</span>
        </h2>
      </div>

      <div className="flex flex-col">
        {MANIFESTO.map((m, i) => (
          <motion.div
            key={m.no}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.4 }}
            className="grid grid-cols-1 items-start gap-6 border-t border-white/10 py-10 md:grid-cols-12 md:gap-8 md:py-14"
          >
            <span className="font-display text-6xl font-black leading-none text-stroke md:col-span-3 md:text-8xl">
              {m.no}
            </span>
            <h3 className="font-display text-2xl font-bold text-white md:col-span-5 md:text-3xl">
              {m.title}
            </h3>
            <p className="text-base leading-relaxed text-white/60 md:col-span-4 md:text-lg">
              {m.body}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
